import { css } from '@/styled-system/css';

export const textContainerStyles = css.raw({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'row',
  marginTop: '400',
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  backgroundColor: 'gray.100',
  // oxlint-disable-next-line constellation/no-raw-spacing-values
  gap: '19px',
  textAlign: 'center',
  alignItems: 'center',
});

export const rentPriceStyles = css.raw({
  width: '50%',
  textAlign: 'center',
  borderRight: '1px solid {colors.border.subtle}',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '1500',
});
